import React from "react";
import PropTypes from "prop-types";
import { Icon } from "signoxe/components/widgets";
import "./styles.scss";

const ReportSummary = ({
  title,
  onProceed,
  data,
  onOptionSelect,
  type,
  isAllSelected,
  onSelectAll,
  campaignIds,
  deviceIds,
  selectedType,
  handleSearch,
  searchTerm
}) => {
  return (
    <div className="ReportSummary">
      <div className="ReportSummary__header flex flex-jc-sb flex-ai-c">
      <div className="input-group w-60">
          <input
            className="input-group-field"
            type="text"
            value={searchTerm}
            placeholder="Enter Search Keyword.."
            onChange={handleSearch}
          />
          <span className="input-group-label">
            <Icon title="Search" name="search" size="1rem" />
          </span>
        </div>
        <div>
        <h2>{title}</h2>
        </div>
      </div>
      <div className="ReportSummary__content">
        <div className="ReportSummary__content__deviceList">
          <div className="ReportSummary__content__deviceListRow header">
            <div className="ReportSummary__content__deviceListColum">Name</div>
            <div className="ReportSummary__content__deviceListColum">
              <span>Select All</span> &nbsp;
              <input
                type="checkbox"
                onChange={() => onSelectAll(type)}
                checked={isAllSelected && selectedType === type}
              />
            </div>
          </div>

          {data &&
            data.length > 0 &&
            data.filter(item => {
              if (searchTerm === '') {
                  return data;
              } else if (item.name.toLowerCase().includes(searchTerm.toLowerCase())) {
                  return data;
              }
          }).map((item, i) => (
              <div className="ReportSummary__content__deviceListRow" key={i}>
                <div className="ReportSummary__content__deviceListColum">
                  {item.name}
                </div>
                <div className="ReportSummary__content__deviceListColum">
                  <input
                    type="checkbox"
                    name="all"
                    value={item.id}
                    onChange={() => onOptionSelect(item.id, type, item.device_id)}
                    checked={
                      type === "device"
                        ? deviceIds &&
                          deviceIds.findIndex((device) => device == item.id) !==
                            -1
                        : campaignIds &&
                          campaignIds.findIndex(
                            (campaign) => campaign == item.id
                          ) !== -1
                    }
                  />
                </div>
              </div>
            ))}
        </div>
      </div>
      <div
        className="ReportSummary__content__deviceListFooter"
        onClick={() => onProceed(type, data)}
      >
        <button>Click to proceed</button>
      </div>
    </div>
  );
};

ReportSummary.propTypes = {
  devices: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  on: PropTypes.bool.isRequired,
};

export default ReportSummary;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/ReportSummary/index.js